import { render, staticRenderFns } from "./ElementSettings.vue?vue&type=template&id=6c26e726&scoped=true&"
import script from "./ElementSettings.vue?vue&type=script&lang=ts&"
export * from "./ElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26e726",
  null
  
)

export default component.exports